import { TabSliderForm } from "./tab-slider-form";
import { TabSliderHandler } from "./tab-slider-handler";
import { TabSliderListener } from "./tab-slider-listener";

/**
 * Tab Slider Setup (V2)
 */
export class TabSliderSetup {
    public form: TabSliderForm;

    public handler: TabSliderHandler;

    public listener: TabSliderListener;

    public constructor(root: HTMLElement) {
        this.form = new TabSliderForm(root);
        this.handler = new TabSliderHandler(this.form);
        this.listener = new TabSliderListener(this.form, this.handler);
    }

    public init(): void {
        const root = this.form.getRoot();
        if (!(root instanceof HTMLElement)) return;
        if (this.form.isInitialized()) return;

        this.handler.bootstrap();
        this.listener.register();
        this.form.markInitialized();
    }

    public static init(rootEl?: ParentNode | Document | HTMLElement | null): void {
        const root = rootEl || document;
        if (!(root instanceof Document || root instanceof HTMLElement)) return;

        TabSliderForm.getRoots(root).forEach((node) => {
            const instance = new TabSliderSetup(node);
            instance.init();
        });
    }
}
